export default "__VITE_ASSET__CStKwHck__"